module.exports = __webpack_public_path__ + "img/popup-btn-owner.d011248.png";